const SupportedLanguagesTestIDs = {
  description: 'supported-languages-description',
  descriptionText: 'supported-languages-description-text',
  list: 'supported-languages-list',
  row: (langValue: string) => `language-row-${langValue}`,
  checkboxContainer: (langValue: string) => `checkbox-container-${langValue}`,
  checkbox: (langValue: string) => `checkbox-${langValue}`,
  languageText: (langValue: string) => `supported-language-text-${langValue}`,
  languageLabel: (langValue: string) => `supported-language-label-${langValue}`,
  requiredTextContainer: 'supported-language-es-required-text',
  requiredText: 'supported-language-required-text',
};

export default SupportedLanguagesTestIDs;
